/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Section_05_TitleInputs */

const en_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to review.`)
};

const de_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vom Upload zum Angebot — automatisiert.`)
};

const fr_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const es_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const it_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const nl_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const pl_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const fi_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const da_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

const sv_landing_section_05_title = /** @type {(inputs: Landing_Section_05_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From upload to offer — automated.`)
};

/**
* | output |
* | --- |
* | "From upload to review." |
*
* @param {Landing_Section_05_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_section_05_title = /** @type {((inputs?: Landing_Section_05_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Section_05_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_section_05_title(inputs)
	if (locale === "fr") return fr_landing_section_05_title(inputs)
	if (locale === "es") return es_landing_section_05_title(inputs)
	if (locale === "it") return it_landing_section_05_title(inputs)
	if (locale === "nl") return nl_landing_section_05_title(inputs)
	if (locale === "pl") return pl_landing_section_05_title(inputs)
	if (locale === "fi") return fi_landing_section_05_title(inputs)
	if (locale === "da") return da_landing_section_05_title(inputs)
	if (locale === "sv") return sv_landing_section_05_title(inputs)
	return en_landing_section_05_title(inputs)
});